<div
  [ngClass]="{'border-bottom-0': hideBorder}"
  class="py-2 pt-md-0 pb-md-4 contract-item-container"
  data-e2e="contracts-options"
>
  @if (icon) {
  <div>
    <img alt="" [src]="icon" />
  </div>
  }
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <h2 class="h3 mb-0" data-e2e="offerName">{{terminatedContractViewModel?.offerName}}</h2>
      <div class="lead text-gray3">{{terminatedContractViewModel?.detail}}</div>
      @if (terminatedContractViewModel?.member) {
      <div class="text-smagenta1 font-weight-bold mt-1">{{terminatedContractViewModel.member.displayName}}</div>
      }
    </div>
    <div class="col-12 col-md-6 col-lg-7 mt-1 mt-md-0">
      @if (terminatedContractViewModel?.billItem?.lastBillStatus) {
      <div>
        <div class="h3 text-primary mb-0">{{terminatedContractViewModel?.billItem?.lastBillAmount}}</div>
        <div class="lead text-gray3 mb-1 mb-md-0">
          {{"dashboard.bills.billText" | translate}} {{terminatedContractViewModel?.billItem?.lastBillDate | date:'dd
          MMMM yyyy'}}
        </div>
      </div>
      }
      <div class="d-flex justify-content-center justify-content-sm-start">
        <a
          class="btn btn-secondary"
          [ngClass]="terminatedContractViewModel?.billItem?.lastBillStatus ? 'mt-2' : 'mt-0'"
          [href]="billLink | link: ParamsUtils.cidMap(terminatedContractViewModel.cid) | async"
          (click)="openBill();false"
        >
          {{labelButton}}</a
        >
      </div>
    </div>
  </div>
</div>
